import { useCallback } from 'react';
import { IGustoMe } from '../../../types/types';
import useGustoAxios from '../../useGustoAxios/useGustoAxios';

export default function useGustoGetMe() {
  const axios = useGustoAxios();
  return useCallback(async () => {
    const { data } = await axios.get<IGustoMe>('/v1/me');
    return data;
  }, [axios]);
}
